/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from "react";
import PropTypes from "prop-types";

import OkSelect from "shared/components/oknf/OkSelect";
import Actions from "../actions/Actions";

class PriceOptions extends React.Component {
	_onChange = (e) => {
		const i = parseInt(e.target.value, 10);
		return Actions.switchSelectedOption(i);
	};

	_getLabel = (option) => {
		const {
			name,
			units,
			displayUnitPrice,
			displayPrice,
			displayTax,
			displayTotal,
		} = option;

		let { unitname } = this.props.product;

		// `unitname` is actually a tuple of unitnames
		const unitNames = unitname;

		const S = this.props.currencySymbol;

		if (unitNames != null) {
			unitname = unitNames[units === 1 ? 0 : 1];
			const firstUnitName = unitNames[0];
			const shortName = firstUnitName.slice(0, 2);
			return `${S}${displayUnitPrice}/${shortName} – ${units} ${unitname}`;
		} else {
			return name;
		}
	};

	render() {
		return (
			<div className="okpay-priceoptions">
				<OkSelect
					options={this.props.options.map((option, i) => {
						return { value: `${i}`, name: this._getLabel(option) };
					})}
					className="okpay-priceoptions-select"
					value={`${this.props.optionPicked}`}
					onChange={this._onChange}
				/>
			</div>
		);
	}
}

export default PriceOptions;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/PriceOptions.jsx